import React, { useEffect, useRef } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon';
import SlAlert from '@shoelace-style/shoelace/dist/react/alert';
import type SlAlertElement from '@shoelace-style/shoelace/dist/components/alert/alert';

import { useDebounce, useNewsletter } from '../../hooks';
import { ArrowRightIcon } from '../../img/icons';
import SpinLoader from '../SpinLoader';

import './index.scss';
import messages from './messages';

const Newsletter = () => {
  const notificationRef = useRef<SlAlertElement | null>(null);

  const intl = useIntl();
  const {
    newsletterNotif,
    submitToNewsletter,
    submitting,
    setEmail,
    email,
  } = useNewsletter();

  useDebounce(() => {
    if (newsletterNotif?.msg && notificationRef?.current) {
      if ('toast' in notificationRef.current) {
        notificationRef.current?.toast();
      }
    }
  }, 200, [newsletterNotif]);

  useEffect(() => {
    if (newsletterNotif?.success) {
      setEmail('');
    }
  }, [newsletterNotif, setEmail]);

  return (
    <>
      <SlAlert ref={notificationRef} variant={newsletterNotif?.success ? 'success' : 'danger'} duration={5000} closable>
        <SlIcon slot="icon" name={newsletterNotif?.success ? 'check2-circle' : 'exclamation-octagon'} />
        <strong>{newsletterNotif?.msg}</strong>
      </SlAlert>
      <div className="overlap-group2-1">
        <div className="overlap-group1-2">
          <p className="sign-up-to-our-newsletter instrumentserif-normal-white-34px">
            {intl.formatMessage(messages.signupNewsletter)}
          </p>
        </div>
        <div className="email-input">
          <div className="button">
            <input
              className="enter-email-adress instrumentsans-normal-white-26px"
              placeholder={intl.formatMessage(messages.enterEmail)}
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            type="button"
            className="button-1 button-4"
            onClick={() => {
              if (!submitting) { submitToNewsletter(email); }
            }}
          >
            {!submitting ? (
              <div className="text-13 instrumentsans-normal-congress-blue-26px">
                <ArrowRightIcon color="#0A3887" />
              </div>
            ) : (
              <SpinLoader size={25} color="var(--cobalt-2)" />
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
